import { makeAction } from "async-action-creator";

import api from "../../utils/api";
import { createApiThunk } from "../../utils/thunk";

export const FETCH_ANALYTICS_CANDIDATES_OPPS = makeAction(
  "analytics/FETCH_ANALYTICS_CANDIDATES_OPPS"
);
export const FETCH_ANALYTICS_OPPORTUNITIES = makeAction(
  "analytics/FETCH_ANALYTICS_OPPORTUNITIES"
);

export const FETCH_ANALYTICS_CANDIDATES_PROFESSIONS = makeAction(
  "analytics/FETCH_ANALYTICS_CANDIDATES_PROFESSIONS"
);

export const FETCH_ANALYTICS_AVERAGE_TIME = makeAction(
  "analytics/FETCH_ANALYTICS_AVERAGE_TIME"
);

export const fetchAnalyticsCandidatesOpps = createApiThunk({
  action: FETCH_ANALYTICS_CANDIDATES_OPPS,
  request: ({ headquarter, company, team, opportunity }, state) => {
    return opportunity && opportunity.id
      ? api.analytics.candidates.opps.opportunity(
          opportunity.idCompany,
          opportunity.id
        )
      : team && team.id
      ? api.analytics.candidates.opps.team(team.idCompany, team.id)
      : company && company.id
      ? api.analytics.candidates.opps.company(company.id)
      : api.analytics.candidates.opps.company(headquarter.id);
  }
});

export const fetchAnalyticsOpportunities = createApiThunk({
  action: FETCH_ANALYTICS_OPPORTUNITIES,
  request: ({ headquarter, company, team }, state) => {
    return team && team.id
      ? api.analytics.opportunities.team(team.idCompany, team.id)
      : company && company.id
      ? api.analytics.opportunities.company(company.id)
      : headquarter &&
        headquarter.id &&
        api.analytics.opportunities.company(headquarter.id);
  }
});

export const fetchAnalyticsCandidatesProfessions = createApiThunk({
  action: FETCH_ANALYTICS_CANDIDATES_PROFESSIONS,
  request: ({ headquarter, company, team, opportunity }, state) => {
    return opportunity && opportunity.id
      ? api.analytics.candidates.professions.opportunity(
          opportunity.idCompany,
          opportunity.id
        )
      : team && team.id
      ? api.analytics.candidates.professions.team(team.idCompany, team.id)
      : company && company.id
      ? api.analytics.candidates.professions.company(company.id)
      : api.analytics.candidates.professions.company(headquarter.id);
  }
});

export const fetchAnalyticsAverageTime = createApiThunk({
  action: FETCH_ANALYTICS_AVERAGE_TIME,
  request: ({ headquarter, company, team, opportunity }, state) => {
    return opportunity && opportunity.id
      ? api.analytics.averageTime.opportunity(
          opportunity.idCompany,
          opportunity.id
        )
      : team && team.id
      ? api.analytics.averageTime.team(team.idCompany, team.id)
      : company && company.id
      ? api.analytics.averageTime.company(company.id)
      : api.analytics.averageTime.company(headquarter.id);
  }
});
